import ApolloClient from "apollo-client"
import { NormalizedCacheObject } from "apollo-cache-inmemory"
import { GET_HELP_CENTER } from "./graphql"

const fetchHelpCenter = async (client: ApolloClient<NormalizedCacheObject>, id) => {
  try {
    return await client.query({
      query: GET_HELP_CENTER,
      variables: {
        WhereInput: {
          category: id
        }
      }
    })
  } catch (error) {
    console.log("Error:", { error })
    return []
  }
}

export { fetchHelpCenter }
